import * as React from "react";
const MyorderIconSvg = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.25 6.39167V5.58334C6.25 3.70834 7.75833 1.86667 9.63333 1.69167C11.8667 1.47501 13.75 3.23334 13.75 5.42501V6.57501"
      stroke="#676C6F"
      strokeWidth={1.25}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49937 18.3333H12.4994C15.8494 18.3333 16.4494 16.9916 16.6244 15.3583L17.2494 10.3583C17.4744 8.32496 16.891 6.66663 13.3327 6.66663H6.66603C3.1077 6.66663 2.52437 8.32496 2.74937 10.3583L3.37437 15.3583C3.54937 16.9916 4.14937 18.3333 7.49937 18.3333Z"
      stroke="#676C6F"
      strokeWidth={1.25}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9121 10H12.9196"
      stroke="#676C6F"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.07811 10H7.08559"
      stroke="#676C6F"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MyorderIconSvg;
